import { FormEvent, useState } from 'react';
import { request } from '../lib/api';
import { needsKey, needsTotp, totpError, type CustomerLoginResult } from '../lib/authSecurity';
import type { UserSessionResponse } from '../lib/userSession';

export function TotpLoginPrompt({ magicToken, onSuccess }: { magicToken: string; onSuccess: (session: UserSessionResponse) => void }) {
  const [code, setCode] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const verify = async (event: FormEvent) => {
    event.preventDefault(); setPending(true); setError(null);
    try {
      const { challengeId } = await request<{ challengeId: string }>('/auth/totp/login/options', { method: 'POST', body: JSON.stringify({ magicToken }) });
      const result = await request<CustomerLoginResult>('/auth/totp/login/verify', { method: 'POST', body: JSON.stringify({ challengeId, code: code.trim() }) });
      if (needsKey(result)) throw { data: { message: 'Your account requires a registered key or passkey. Sign in again with that credential.' } };
      if (needsTotp(result)) throw { data: { message: 'Authenticator verification is incomplete. Enter the current code and try again.' } };
      onSuccess(result);
    } catch (err) { setError(totpError(err)); setCode(''); }
    finally { setPending(false); }
  };
  return <form className="form-stack" onSubmit={verify}>
    <h2>Enter your authenticator code</h2>
    <p className="helper-text">Your email or Google sign-in is verified. Finish sign-in with the six-digit code from your authenticator app.</p>
    {error ? <div className="alert" role="alert">{error}</div> : null}
    <label>Authenticator code<input type="text" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} required value={code} onChange={event => setCode(event.target.value)} disabled={pending} /></label>
    <button className="button-primary" type="submit" disabled={pending}>{pending ? 'Verifying...' : 'Verify authenticator code'}</button>
  </form>;
}
